import { attr, belongsTo, hasMany } from 'spraypaint'
import ApplicationRecord from './ApplicationRecord'

const School = ApplicationRecord.extend({
  static: {
    jsonapiType: 'schools',
  },
  attrs: {
    appointmentInterval: attr(),
    name: attr(),
    districtId: attr(),
    address: attr(),
    accessCodeOnly: attr(),
    scode: attr(),
    phone: attr(),
    route: attr(),
    principal: attr(),
    prinEmail: attr(),
    schoolTypeId: attr(),
    secretary: attr(),
    sec1Email: attr(),
    salesStat: attr(),
    cityName: attr(),
    scheduleLocation: attr(),
    seniorLocation: attr(),
    whatToWear: attr(),
    girlsDressCode: attr(),
    boysDressCode: attr(),
    seniorSessionInformation: attr(),
    seniorSessionExtraInformation: attr(),
    studentImageStatus: attr(),
    districtName: attr(),
    // Contact fields for Requested By dropdown
    prinFname: attr(),
    prinLname: attr(),
    vpFname: attr(),
    vpLname: attr(),
    vpEmail: attr(),
    ybFname: attr(),
    ybLname: attr(),
    ybEmail: attr(),
    sec1Fname: attr(),
    sec1Lname: attr(),
    sec2Fname: attr(),
    sec2Lname: attr(),
    sec2Email: attr(),
    noPersonalization: attr(),
    // extra_attribute — only populated when requested via selectExtra(['senior_background_url'])
    seniorBackgroundUrl: attr(),
    students: hasMany(),
    packages: hasMany(),
    notes: hasMany(),
    district: belongsTo(),
  },
})

export default School
